module.exports = __webpack_public_path__ + "img/3_floor.df4f8134.png";